export default "__VITE_ASSET__ByJiQ9ED__"